export class CustomerCancelApartment {
  public CancelAptID: number;
  public CustomerID: Number;
  public ProofDocument: string;
  public Remarks: string;
  public CreatedOn: Date;
  public Status: Boolean;
  public IsAgentApproved: Boolean;
  public IsHeadApproved: Boolean;
  public IsDirectorApproved: Boolean;
  public CancelledOn: Date;
  public RefundAmount: number;
  public RefundDate: Date;
  public AccountName: string;
  public AccountNumber: string;
  public BankBranch: string;
  public IFSCCode: string;
  public CancelRequestDocument: string;
  public DocumentFile: File;
  public RefundDocumentFile : File;
  public RefundStatus: Number;
  public RefundIntiateAmount: Number;
  public BlankCheque: File;
  public RefundRequestDocument :string;
  public CancelStatus: number;
  WithDrawRequestDate: Date;
}
